import { render, staticRenderFns } from "./SisProgrammeStatusBar.vue?vue&type=template&id=bd0a066e&"
import script from "./SisProgrammeStatusBar.vue?vue&type=script&lang=ts&"
export * from "./SisProgrammeStatusBar.vue?vue&type=script&lang=ts&"
import style0 from "./SisProgrammeStatusBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports